import { assert } from '../../../app/logger.js';
import { LayerLeaflet } from './layer_leaflet.js';
import { MarkerBaseMixin } from '../base/marker_base_mixin.js';

/**
 * A wrapper around leaflet marker.
 */
class MarkerLeaflet extends MarkerBaseMixin(LayerLeaflet) {
  static Standard(options) {
    return new MarkerLeaflet(options);
  }

  get name() {
    return this.options.name || this.options.title;
  }

  get title() {
    return this.options.title;
  }

  set title(v) {
    this.options.title = v;
    if (this.native) {
      this.native.options.title;
    }
  }

  get position() {
    return this.native ? this.native.getLatLng() : this.options.position;
  }

  set position(v) {
    assert(v, `[map:marker:leaflet] no position`);
    assert(v.lat, `[map:marker:leaflet] no position.lat`);
    assert(v.lng, `[map:marker:leaflet] no position.lng`);
    this.options.position = v;
    if (this.native) {
      this.native.setLatLng(v);
    }
  }

  get icon() {
    // TODO: Leaflet's getIcon should be converted to internal format.
    return this.native ? this.native.getIcon() : this.options.icon;
  }

  set icon(v) {
    this.options.icon = v;
    if (this.native) {
      this.native.setIcon(this.getNativeOption('icon', v));
    }
  }

  // Protected

  createNative() {
    return new window.L.Marker(this.options.position, this.nativeOptions);
  }

  static get nativeOptionsMapper() {
    return Object.assign({}, super.nativeOptionsMapper, {
      title: 'title',
      icon: icon =>
        (icon &&
          window.L.icon({
            iconUrl: icon.url,
            iconSize: icon.size && [icon.size.width, icon.size.height],
            iconAnchor: icon.anchor,
          })) ||
        undefined,
    });
  }
}

export { MarkerLeaflet };
